import { render, staticRenderFns } from "./TableauDeBordAchat.vue?vue&type=template&id=d3c116e6&"
import script from "./TableauDeBordAchat.vue?vue&type=script&lang=ts&"
export * from "./TableauDeBordAchat.vue?vue&type=script&lang=ts&"
import style0 from "./TableauDeBordAchat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports